import { Component, OnInit } from '@angular/core';
import { OttoOlsenProductsInCartComponent } from '../otto-olsen-products-in-cart/otto-olsen-products-in-cart.component';

@Component({
    selector: 'otto-olsen-mobile-checkout',
    templateUrl: './otto-olsen-mobile-checkout.component.html',
    styleUrls: ['./otto-olsen-mobile-checkout.component.scss'],
    standalone: false
})
export class OttoOlsenMobileCheckoutComponent extends OttoOlsenProductsInCartComponent {}
